import { render, staticRenderFns } from "./BCDOverview.vue?vue&type=template&id=d0c688b8&scoped=true"
import script from "./BCDOverview.vue?vue&type=script&lang=js"
export * from "./BCDOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0c688b8",
  null
  
)

export default component.exports